import { createAction, props, union } from '@ngrx/store';
import { PolicyDetails } from '@app/features/dashboard/models/policy-details';
import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export const load = createAction(
  '[Dashboard] Load',
);

export const loadSuccess = createAction(
  '[Dashboard] Load Success',
  props<{ policyDetails: PolicyDetails }>()
);

export const loadFail = createAction(
  '[Dashboard] Load Fail',
  props<{ error: string }>()
);

export const changePolicy = createAction(
  '[Dashoboard] Change Policy',
  props<{ alterOptions: KeyValueDict<boolean> }>()
);

export const changePolicyDate = createAction(
  '[Dashoboard] Change Policy Date',
  props<{ policyChangeDate: Date }>()
);

export const changePolicyEndDate = createAction(
  '[Dashoboard] Change Policy End Date',
  props<{ policyChangeEndDate: Date }>()
);

export const changeMovedAlready = createAction(
  '[Dashoboard] Moved To New Address',
  props<{ hasMovedAlready: boolean | null }>()
);

export const changePolicyType = createAction(
  '[Dashoboard] Change Policy Type',
  props<{ policyChangeType: string }>()
);

export const changePromoCode = createAction(
  '[Dashoboard] Change Promo Code',
  props<{ promoCode: string}>()
);

export const changeRenewal = createAction(
  '[Dashoboard] Change Renewal',
  props<{ renewal: string }>()
);

const all = union({load, loadSuccess, loadFail, changePolicy, changePolicyDate, changePolicyType, changePolicyEndDate, changePromoCode, changeRenewal});
export type DashboardActionsUnion = typeof all;
